//Mixin de transfert bilatéral du v-model
export const ednTransform = {
  data() {
    return {
      oTextTransform:{
        CASE_NONE : '',
        CASE_UPPER : 'text-uppercase',  
        CASE_CAPITALIZE : 'text-capitalize',
        CASE_LOWER : 'text-lowercase', 
        CASE_CUSTOM : ''
      }
    }
  },
  props:{
    textTransform:{
      default:() => "",
      type:String
    }
  },
  computed: {
    getTextTransform() {
      return this.oTextTransform[this.textTransform] || "";
    }
  },
  methods: {
  },
}
